export const ERROR_AUTHORIZATION_HEADER_EMPTY_IN_THE_REQUEST = 401;
export const ERROR_ACCESS_TOKEN_HAS_EXPIRED = 99001;
export const ERROR_NO_CHANNELS_ASSIGNED = 10169;
export const ERROR_FLOORPLAN_EVENT_PAST = 10224;
